import { http } from '@shared/api/http-client';
import type { AdminUser, LoginCredentials, Session } from '@features/auth/model/auth.types';

/**
 * The only place that knows the auth endpoints. Hooks and components call these
 * functions, so a route change touches exactly one file.
 */
export const authApi = {
  login(credentials: LoginCredentials): Promise<Session> {
    return http.post<Session>('/auth/login', credentials);
  },

  me(): Promise<AdminUser> {
    return http.get<AdminUser>('/auth/me');
  },

  logout(): Promise<void> {
    return http.post<void>('/auth/logout');
  },

  /** Always resolves, whether or not the address belongs to an admin. */
  requestPasswordReset(email: string): Promise<void> {
    return http.post<void>('/auth/password-reset/request', { email });
  },

  /** Checks a code without spending it, so the UI can advance a step. */
  verifyResetCode(email: string, code: string): Promise<void> {
    return http.post<void>('/auth/password-reset/verify', { email, code });
  },

  resetPassword(email: string, code: string, password: string): Promise<void> {
    return http.post<void>('/auth/password-reset/confirm', { email, code, password });
  },
};
